import Loading from "@/components/inc/Loading";
import HelpIcon from "@/components/help/HelpIcon";
import formatCurrency from "@/helpers/format_currency";
import formatDecimal from "@/helpers/format_decimal";
import formatTimestamp from "@/helpers/format_timestamp";
import { activityTypes, orderStates, roles, rules, ticketStates } from "@/helpers/get_constants";
import "@fortawesome/fontawesome-free/css/all.css";
import config from "Config/config";
import moment from "moment";
import Vue from "vue";
import VueDraggable from "vue-draggable";
import VueMoment from "vue-moment";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import zhHans from "vuetify/es5/locale/es";
import App from "./App";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

require("moment/locale/es");
moment.locale("es");

const { auth, messaging } = require("./config/firebase");

const EventBus = new Vue();
export default EventBus;

if (messaging) {
  messaging.onMessage((payload) => {
    EventBus.$emit("setNotification", payload.data);
  });
}

Vue.use(VueMoment, { moment });
Vue.use(Vuetify);
Vue.use(VueDraggable);

Vue.prototype.$roles = roles;
Vue.prototype.$rules = rules;
Vue.prototype.$ticketStates = ticketStates;
Vue.prototype.$orderStates = orderStates;
Vue.prototype.$activityTypes = activityTypes;
Vue.prototype.$formatTimestamp = formatTimestamp;
Vue.prototype.$currency = config.currency || { code: "PEN", symbol: "S/" };
Vue.prototype.$formatCurrency = formatCurrency;
Vue.prototype.$formatDecimal = formatDecimal;

Vue.component("ShowLoading", Loading);
Vue.component("HelpIcon", HelpIcon);

const opts = {
  lang: {
    locales: { zhHans },
    current: "zhHans",
  },
  icons: {
    iconfont: "fa",
  },
  theme: config.theme,
};

/* eslint-disable no-new */
auth.onAuthStateChanged(() => {
  // if (user && !user.emailVerified) return;

  new Vue({
    vuetify: new Vuetify(opts),
    el: "#root",
    router,
    store,
    components: { App },
    template: "<App/>",
  });
});
